import React, { useEffect, useRef } from 'react';
import { Alert, Button, CircularProgress, FormHelperText, Grid, IconButton, TextField, Typography, } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { jobActions } from '../../../redux/reducers/job-slice';
import useAxiosPrivate from '../../../hooks/use-axios-private';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { alertMsg } from '../../../utils/basicUtils';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { getFilePromise, RAW_FILE_TYPES, readEntryPromise } from '../../../utils/fileUtils';
import { humanFileSize } from '../../../utils/basicUtils';
import { closeSnackbar } from 'notistack';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import { MD5 } from 'crypto-js';

const UploadImage = ({ itemData, index, onDelete, checkBoxChange, isChecked, onCancelledDelete, isTransferring }) => {
	const theme = useTheme();
	return (
		<Grid item key={itemData[index].name} sx={{ padding: "10px" }} >
			{!itemData[index].status
				&&
				<Box sx={{ position: "relative", borderRadius: '6px 6px 0px 0px', width: { xs: "180px", sm: "156px" }, height: "150px", background: "#ebecf0", display: "flex", alignItems: "center", justifyContent: "center" }}>
					<CircularProgress />
					<Box sx={{ position: 'absolute', width: "100%", bottom: "0px", left: "0px", background: "#00000061", borderRadius: "0 0 15px 0", boxShadow: "1px 1px 2px 0px #0b134554" }}>
						<Typography variant="body2" color="initial" sx={{
							textTransform: "uppercase", padding: "2px 2px 2px 4px", fontSize: 12, color: "#fff",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "-webkit-box",
							WebkitLineClamp: "1",
							WebkitBoxOrient: "vertical",
						}}>
							{itemData[index].file && humanFileSize(itemData[index].file.size)}
						</Typography>
					</Box>
				</Box>
			}

			{itemData[index].status === 1 &&
				<Box sx={{ width: { xs: "180px", sm: "156px" }, height: "150px", position: "relative", borderRadius: '6px 6px 0px 0px', overflow: "hidden" }}>
					<img style={{ width: "100%", height: "100%", objectFit: "cover" }}
						src={`${itemData[index].preview_url}`}
						alt={itemData[index].name}
						loading="lazy" />
					{!isTransferring
						&&
						<>
							<IconButton sx={{ position: 'absolute', top: "0px", right: "0px", background: theme.palette.mode === "dark" ? "#5a5a5ac7" : "#ebecf0", borderRadius: "0 0 0 15px", boxShadow: "1px 1px 2px 0px #0b134554" }}
								className="image-del-icon"
								onClick={
									(e) => {
										if (e.detail === 1) {
											console.log("🚀 ~ file: UploadImageStep.jsx:58 ~ UploadImage ~ (e.detail:", itemData)

											const img = {
												name: itemData[index].name,
												preview_url: itemData[index].preview_url,
												url: itemData[index].url,
												path: itemData[index].path,
												preview_path: itemData[index].preview_path,
												marked_image: itemData[index].marked_image,
											}
											onDelete([img], [index]);
										}
									}
								}
								aria-label="delete" size="small"
								color='primary'
							>
								<DeleteOutlineOutlinedIcon fontSize="small" />
							</IconButton>
							<FormGroup className='checkbox-pad' sx={{ position: 'absolute', top: "0px", left: "0px", background: theme.palette.mode === "dark" ? "#5a5a5ac7" : "#ebecf0", borderRadius: "0 0 15px 0", boxShadow: "1px 1px 2px 0px #0b134554" }}>
								<FormControlLabel
									sx={{ m: 0, padding: "0px" }}
									control={<Checkbox
										checked={isChecked}
										onChange={(e) => { checkBoxChange(e) }}
									/>}
								/>
							</FormGroup>
						</>
					}
					<Box sx={{ position: 'absolute', width: "100%", bottom: "0px", left: "0px", background: "#00000061", borderRadius: "0 0 15px 0", boxShadow: "1px 1px 2px 0px #0b134554" }}>
						<Typography variant="body2" color="initial" sx={{
							textTransform: "uppercase", padding: "2px 2px 2px 4px", fontSize: 12, color: "#fff",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "-webkit-box",
							WebkitLineClamp: "1",
							WebkitBoxOrient: "vertical",
						}}>
							{humanFileSize(itemData[index].file_size)}
						</Typography>
					</Box>
				</Box>
			}

			{itemData[index].status === 2
				&&
				<Box sx={{ width: { xs: "100%", sm: "156px" }, height: "150px", background: "#ebecf0", display: "flex", alignItems: "center", justifyContent: "center" }}>
					<IconButton
						onClick={() => {
							if (isTransferring) {
								return false
							}
							onCancelledDelete();
						}}
					>
						<CloseIcon />
					</IconButton>
				</Box>
			}
			<Box sx={{ width: { xs: "180px", sm: "156px" }, backgroundColor: theme.palette.mode === "dark" ? '#5a5a5a' : '#ebecf0', borderRadius: "0px 0px 6px 6px", overflow: "hidden" }}>
				<Box >
					<Typography sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						display: "-webkit-box",
						WebkitLineClamp: "1",
						WebkitBoxOrient: "vertical",
						margin: '8px',
					}} component="p" fontSize={13} >{itemData[index].name}</Typography>
				</Box >
			</Box>
		</Grid>
	)
}

const UploadImageStep = ({ enableNext, enableBack, saveJobToDraft }) => {
	const controllerRef = useRef(new AbortController())
	const isUnmounted = useRef(false);
	const canceltransferRef = useRef(false)
	const [isTransferring, setIsTransferring] = useState(false)
	const theme = useTheme();
	const dispatch = useDispatch()
	const job = useSelector(state => state.job)
	const axios = useAxiosPrivate()
	const [filesToBeUploaded, setFilesToBeUploaded] = useState(0) //For image upload progress count
	const [itemData, setItemData] = useState([...job.media])
	const [deleteSelected, setDeleteSelected] = useState([])
	const cancelledMsgRef = useRef(false)

	useEffect(() => {
		isUnmounted.current = false
		return () => {
			isUnmounted.current = true
			canceltransferRef.current = true
			controllerRef.current.abort()
		}
	}, [])

	useEffect(() => {
		!isTransferring ? enableBack(true) : enableBack(false)
	}, [isTransferring, enableBack])
	//For image upload progress count

	useEffect(() => {
		setFilesToBeUploaded(prev => prev === 0 ? job.media.length : prev)
	}, [job.media,])

	useEffect(() => {
		enableNext(!isTransferring && itemData.some(({ status }) => status === 1))
		return () => {
			enableNext(false)
		}
	}, [enableNext, itemData, isTransferring])

	const uploadImage = async (file) => {
		let formData = new FormData();
		formData.append("job_id", job.job_id);
		formData.append("image", file);
		formData.append("mime_type", file.type);
		try {
			let resp = await axios.post('jobs/upload/', formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			return resp
		}
		catch (e) {
			console.error("🚀 ~ file: UploadImageStep.jsx:49 ~ uploadImage ~ e:", e)
			return false
		}
	}

	const chunkUploader = async (file) => {
		try {
			const chunkSize = 1024 * 1024 * 5; // 1MB chunks (you can adjust this)
			const totalChunks = Math.ceil(file.size / chunkSize);
			let reqPromises = []
			const resp1 = await axios.post(`/jobs/confirm_upload/`, { job_id: job.job_id, file_name: file.name, file_size: file.size })
			const uploadUrl = resp1.data.data.upload_details.url
			const uploadId = resp1.data.data.upload_details.upload_id
			for (let i = 0; i < totalChunks; i++) {
				const start = i * chunkSize;
				const end = Math.min(file.size, (i + 1) * chunkSize);
				const chunk = file.slice(start, end);
				const currentChunkRange = (i * chunkSize)
				const formData = new FormData();
				formData.append('image', chunk);
				formData.append('file_start', currentChunkRange);
				formData.append('file_end', i === totalChunks ? file.size : currentChunkRange + chunk.size);
				const resp = await axios.put(`jobs/upload/${uploadId}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						// "Content-Range": `bytes ${currentChunkRange}-${currentChunkRange + chunk.size} / ${file.size}`
					}
				})
				reqPromises.push(resp)

			}
			// await Promise.all(reqPromises)
			const resp = await axios.post(`jobs/complete_upload/`, { upload_id: resp1.data.data.upload_details.upload_id, file_hash: MD5(file).toString() },)
			console.log("🚀 ~ file: Chunk.jsx:46 ~ handleUpload ~ resp:", resp)
			return resp
		}
		catch (err) {
			console.log("🚀 ~ file: UploadImageStep.jsx:226 ~ chunUploader ~ err:", err)
			return false
		}

	};

	const handleFileChange = async (e) => {
		e.preventDefault()
		let imglist = []
		let img = []
		if (isTransferring) {
			alertMsg("Files are being uploaded. Please wait until they complete", "warning")
			return
		}
		if (e.nativeEvent.type === 'drop') {
			if (e.dataTransfer.items) {
				// Use DataTransferItemList interface to access the file(s)
				for (let item of e.dataTransfer.items) {
					const entry = item.webkitGetAsEntry();
					if (entry.isDirectory) {
						// Get folder contents
						const contents = await readEntryPromise(entry)
						for (let content of contents) {
							const file = await getFilePromise(content)
							const fileType = file.type
							if (fileType) {
								if (!file.type.includes('image')) {
									console.log("🚀 ~ file: UploadImageStep.jsx:153 ~ handleFileChange ~ file.type:", file)
									alertMsg(`${file.name} unsupported file format`, 'error')
									continue
								}
								imglist.push(file)
							} else {
								const ext = (file.name.split('.').slice(-1) + "").toLowerCase();
								if (!RAW_FILE_TYPES.includes(ext)) {
									console.log("🚀 ~ file: UploadImageStep.jsx:153 ~ handleFileChange ~ file.type:", file)
									alertMsg(`${file.name} unsupported file format`, 'error')
									continue
								}
								imglist.push(file)
							}
						}
					}
					else {
						const file = item.getAsFile();
						if (file.type) {
							if (!file.type.includes('image')) {
								alertMsg(`${file.name} unsupported file format`, 'error')
								continue
							}
						} else {
							const ext = (file.name.split('.').slice(-1) + "").toLowerCase();
							if (!RAW_FILE_TYPES.includes(ext)) {
								console.log("🚀 ~ file: UploadImageStep.jsx:153 ~ handleFileChange ~ file.type:", file)
								alertMsg(`${file.name} unsupported file format`, 'error')
								continue
							}
						}
						imglist.push(file)
					}
				}
			} else {
				// Use DataTransfer interface to access the file(s)
				[...e.dataTransfer.files].forEach((file, i) => {
					if (!file.type.includes('image')) {
						alertMsg(`${file.name} unsupported file format`, 'error')
						return false
					}
					imglist.push(file)
				});
			}

		} else {
			[...e.target.files].forEach((file, i) => {
				if (file.type) {
					if (!file.type.includes('image')) {
						alertMsg(`${file.name} unsupported file format`, 'error')
					}
				}
				else {
					const ext = (file.name.split('.').slice(-1) + "").toLowerCase();
					if (!RAW_FILE_TYPES.includes(ext)) {
						alertMsg(`${file.name} unsupported file format`, 'error')
					}
				}
				imglist.push(file)
			});
		}
		imglist = imglist.filter((img, index) => {
			if (job.media.some(media => media.name === img.name)) {
				alertMsg(`${img.name} is already added`, 'warning')
				return false
			}
			return true
		})
		imglist = imglist.map(file => ({ file: file, status: 0, name: file.name }))
		imglist = [...itemData, ...imglist]
		img.push(...itemData)
		setFilesToBeUploaded(prev => prev === 0 ? job.media.length + imglist.length : imglist.map(img => img.status === 0).length) //For image upload progress count
		setItemData([...imglist])
		const imglistLength = imglist.length
		e.target.value = null
		for (let i = 0; i < imglistLength; i++) {
			setIsTransferring(true)
			if (canceltransferRef.current) {
				canceltransferRef.current = false
				// imglist = imglist.filter(img => img.status === 1)
				setItemData(prev => {
					let img = [...prev]
					img = img.filter(img => img.status === 1)
					return [...img]
				})
				setFilesToBeUploaded(img.length)
				closeSnackbar(cancelledMsgRef.current)
				alertMsg("Transfers cancelled", 'success')
				// setFilesToBeUploaded(imglist.length) //For image upload progress count
				break
			}
			if (!imglist[i].status) {
				try {
					// const res = await uploadImage(imglist[i]['file'])
					const res = await chunkUploader(imglist[i]['file'])
					if (isUnmounted.current) {
						return
					}
					res && dispatch(jobActions.addMedia({
						name: imglist[i].name,
						...res.data.data,
						status: 1,
						hotspots: [],
						marked_image: null,
						has_thumb: true
					})) && img.push({ status: "1" })

					!res && setFilesToBeUploaded(prev => prev - 1) //For image upload progress count
					setItemData(prev => {
						let img = [...prev]
						if (!!res) {
							img[i].file_size = res.data.data.file_size
							img[i].preview_url = res.data.data.preview_url
							img[i].url = res.data.data.url
							img[i].path = res.data.data.path
							img[i].preview_path = res.data.data.preview_path
							img[i].marked_image = null
							img[i].hotspots = []
						}
						img[i].status = (res ? 1 : 2)
						return [...img]
					})
				}
				catch (e) {
					console.error("🚀 ~ file: UploadImageStep.jsx:111 ~ handleFileChange ~ e:", e)
				}
			}
		}
		if (canceltransferRef.current) {
			canceltransferRef.current = false
			closeSnackbar(cancelledMsgRef.current)
			alertMsg("Transfers cancelled", 'success')
		}
		setIsTransferring(false)
	};

	const deleteUploadImage = async (img, index) => {
		try {
			const resp = await axios.post("jobs/delete_upload_image/", {
				"job_id": job.job_id,
				"path": img
			})
			let removeLength = img.length //For image upload progress count
			// let jobMedia = [...job.media]
			// img.forEach(deleteImg => {
			// 	const imgIndex = jobMedia.findIndex(img => img.name === deleteImg.name)
			// 	if (imgIndex >= 0) {
			// 		jobMedia.splice(imgIndex, 1)
			// 	} else {
			// 		console.log(`${deleteImg.name} not found`)
			// 	}
			// })
			dispatch(jobActions.setMedia(resp.data.data.media))
			saveJobToDraft({ ...job, media: [...resp.data.data.media] })

			// dispatch(jobActions.removeMedia([...img]))
			dispatch(jobActions.updateJob(resp.data.data))
			// setItemData(prev => {
			// 	img.forEach((deleteImg) => {
			// 		const imgIndex = prev.findIndex(img => img.name === deleteImg.name)
			// 		if (imgIndex >= 0) {
			// 			prev.splice(imgIndex, 1)
			// 		} else {
			// 			console.log(`${deleteImg.name} not found`)
			// 		}
			// 	})
			// 	return [...prev]
			// })
			setItemData([...resp.data.data.media])
			setDeleteSelected([])
			setFilesToBeUploaded(prev => prev - removeLength) //For image upload progress count
		}

		catch (error) {
			console.error(error)
		}
	}

	const cancelTransfers = () => {
		cancelledMsgRef.current = alertMsg("Cancelling transfers please wait", 'info', { persist: true })
		controllerRef.current.abort();
		canceltransferRef.current = true
		controllerRef.current = new AbortController();
	}

	const deleteCancelledImage = (index) => {
		setItemData(prev => {
			prev.splice(index, 1)
			return [...prev]
		})
	}

	const handleChange = (event, index, item) => {
		setDeleteSelected(
			prev => {
				if (!prev.includes(index)) {
					prev.push(index)
				}
				else {
					const position = deleteSelected.indexOf(index)
					if (position >= 0) {
						prev.splice(position, 1)
					}
				}
				return [...prev]
			}
		)
	}

	const validateOutputFilecount = () => {
		let result = {
			message: '',
			isValid: false
		}

		if (job.media.length === 0 && job.output_file_count !== 0) {
			result.message = "Please upload some images"
			return result
		}
		if (job.output_file_count < 0) {
			result.message = "Output file count should be greater than zero"
			return result
		}
		if (job.output_file_count > 0 && (job.media.length < job.output_file_count)) {
			result.message = `Output file count should not exceed ${job.media.length}`
			return result
		}
		if (job.media.length > 0 && job.output_file_count == 0) {
			result.message = `Output file count cannot be zero`
			return result
		}
		result.isValid = true
		return result
	}

	return (
		<Box
			onDragOver={(e) => {
				e.stopPropagation();
				e.preventDefault();
			}}
			onDrop={e => {
				e.stopPropagation();
				e.preventDefault();
				handleFileChange(e)
			}}
			component="div"
			sx={{ position: 'relative', mt: deleteSelected.length > 0 && { xs: 7, sm: 0 } }}
		>
			<input
				disabled={isTransferring}
				multiple
				type="file"
				onChange={handleFileChange}
				accept=".cr2,.nef,.dng,.cr3,.arw,.xmp,.tif,image/*"
				style={{ display: 'none' }}
				id="image-upload"
			/>

			<Box className="overflow-scroll" sx={{ maxHeight: { xs: "70vh", sm: "45vh", xl: "50vh" }, overflowY: 'auto', border: "2px dashed grey", mt: 4, borderRadius: "4px" }}>
				{itemData.length > 0 &&
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 3, mb: 2, backgroundColor: theme.palette.mode === "dark" ? '#5a5a5a87' : '#ebecf0', position: "sticky", width: "100%", top: 0, zIndex: 1 }}>
						<label htmlFor="image-upload">
							<Button
								variant="contained"
								color="primary"
								component="span"
								startIcon={<CloudUploadOutlinedIcon />}
							>
								Select File
								{isTransferring && <CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", ml: 1, color: "#fff" }} />}
							</Button>
						</label >
					</Box>
				}
				{!itemData.length > 0 &&
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6, px: 3, height: "100%", }}>
						<Box >
							<label htmlFor="image-upload">
								<Button
									variant="contained"
									color="primary"
									component="span"
									startIcon={<CloudUploadOutlinedIcon />}
								>
									Select File
								</Button>
							</label >
						</Box>
					</Box>
				}

				{isTransferring &&
					<Alert severity="info" sx={{ maxWidth: '50%', mx: "auto", display: "flex", justifyContent: "center" }}>Please wait while images are being uploaded..</Alert>
				}
				{
					itemData.length > 0 && <Grid container sx={{ padding: "10px", justifyContent: 'center' }}>
						{itemData.map((item, index) => (

							<UploadImage
								onCancelledDelete={() => deleteCancelledImage(index)}
								key={item.name}
								itemData={itemData}
								index={index}
								onDelete={deleteUploadImage}
								isChecked={deleteSelected.includes(index)}
								checkBoxChange={
									(e) => {
										handleChange(e, index, item)
									}
								}
								isTransferring={isTransferring}
							/>

						))}
					</Grid>
				}

			</Box>

			<Box sx={{ mt: 2 }}>
				<Grid container spacing={2} flexDirection={{ xs: "column-reverse", sm: "row" }}>
					<Grid item xs={12} sm={6}>
						{
							job.media.length > 0 && !isTransferring &&
							<Button sx={{ mr: 1, mb: { xs: 2, md: 0 } }} color='primary' variant="outlined"
								// sx={{ position: 'absolute', bottom: { xs: -50, sm: -70 } }}
								className='delete-selected-btn'
								onClick={() => {
									if (job.media.length === deleteSelected.length) {
										setDeleteSelected([])
										return
									}
									let ids = []
									for (let i = 0; i < job.media.length; i++) {
										ids.push(i)
									}
									setDeleteSelected(ids)
								}}
							>{job.media.length === deleteSelected.length ? "Unselect all" : "Select All"}</Button>
						}

						{
							deleteSelected.length > 0
							&& !isTransferring &&
							<Button color='error' variant="outlined"
								sx={{ mb: { xs: 2, md: 0 } }}
								className='delete-selected-btn'
								onClick={() => {
									let imgList = []
									deleteSelected.forEach((imgIndex) => {
										imgList.push(itemData[imgIndex])
									})
									deleteUploadImage(imgList)
								}}
							>Delete Selected ({deleteSelected.length})</Button>
						}
						{isTransferring &&
							<Button
								variant="outlined"
								className='delete-selected-btn'
								onClick={cancelTransfers}
							// sx={{ position: 'absolute', bottom: { xs: -50, sm: -70 } }}
							>
								Cancel pending Transfer
							</Button>
						}
					</Grid>
					<Grid item xs={12} sm={6}>
						<Box sx={{ textAlign: "right" }}>
							{
								filesToBeUploaded === job.media.length ?
									<Box>
										<CheckCircleIcon sx={{ fontSize: { xs: "20px", xl: "22px" }, verticalAlign: "middle", mr: 1 }} color='success' />
										<Typography variant='span' sx={{ fontSize: { xs: "14px", xl: "16px" } }}>{job.media.length} images uploaded</Typography>
									</Box>
									:
									<Box>
										<CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", mr: 1 }} />
										<Typography variant='span' sx={{ fontSize: { xs: "14px", xl: "16px" } }}>{job.media.length} / {filesToBeUploaded} images uploaded</Typography>
									</Box>
							}
						</Box>
						<Box sx={{ textAlign: "right", mt: 2, width: { xs: "60%", sm: "45%", md: "35%", xl: "25%" }, marginLeft: "auto" }}>
							<TextField
								type='number'
								autoFocus
								onFocus={(e) => { e.target.select() }}
								// error={((filesToBeUploaded === 0 && job.output_file_count > 0) || (filesToBeUploaded > 0 && job.output_file_count > 0 && (job.output_file_count <= filesToBeUploaded))) ? false : true}
								error={!validateOutputFilecount().isValid}
								size='small' label={<><>Output file count</> <Tooltip title="Output file count will helps us in accurate and effective calculation of pricing with respective to input file count">
									<HelpIcon sx={{ position: "relative", top: "4px", cursor: "pointer" }} fontSize="small" /></Tooltip></>} value={job.output_file_count} name="output_file_count"
								onChange={(e) => {
									console.log("🚀 ~ file: UploadImageStep.jsx:617 ~ UploadImageStep ~ e.target.value:", e.target.value)
									const count = e.target.value.replaceAll(".", "").replaceAll("e", "").replaceAll("E", "").replaceAll("-", "").replaceAll("+", "")
									// dispatch(jobActions.updateOutputFileCount(count || 0))
									dispatch(jobActions.updateOutputFileCount(count))
								}
								}
								helperText={validateOutputFilecount().message}
								// onMouseEnter={() => job.output_file_count}
								onMouseLeave={() => job.output_file_count === '' && dispatch(jobActions.updateOutputFileCount(0))}
								// helperText={
								// 	filesToBeUploaded > 0 && ((job.output_file_count > filesToBeUploaded)
								// 		? `Output file count should not exceed ${filesToBeUploaded}` : "")
								// }
								autoComplete='off'
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box >
	);
}


export default UploadImageStep;